export default {
    Demand: 1, // Nhu cầu
    Deliver: 2, // quyết định giao
    New: 3, // Mới

}